<!-- 由 Dioa 创建于 2022-07-18 星期一 -->
<template>
  <div class="MainCoachPop" @touchmove.prevent v-if="mainCoachShow">
    <!-- 确认更换 -->
    <div class="detail-box" v-if="showConfirm">
      <div class="top-hello-text">亲爱的会员您好</div>

      <div class="change-desc">
        <div class="change-desc-text-1">
          我们注意到您近两个月约{{ coachNew['name'] }}教练的课占比较多~
        </div>

        <div class="change-desc-text-2">
          健萌考虑到上课比较多的教练会更了解您的身体情况。为了向您提供更贴心的服务，请问您<span
            class="light"
            >是否需要把专属训练规划师更换为{{ coachNew['name'] }}教练呢？</span
          >
        </div>
      </div>

      <div class="coach-change-wrapper">
        <div class="left-coach-wrapper">
          <img :src="coachOld['image']" alt="" class="coach-avatar" />
          <div class="coach-name">{{ coachOld['name'] }}教练</div>
        </div>

        <!-- https://cdnvue.gymcity.com.cn/uploads/474b47b400369d72944da3aa665924b3.png -->

        <div class="center-change-arrow">
          <div class="change-text">
            <div>专属训练规划师<br />更换为</div>
            <!-- <div>训练规划师</div> -->
          </div>
          <img
            src="https://cdnvue.gymcity.com.cn/uploads/coach-change-arrow"
            alt=""
          />
        </div>

        <div class="right-coach-wrapper">
          <img class="coach-avatar" :src="coachNew['image']" alt="" />
          <div class="coach-name">{{ coachNew['name'] }}教练</div>
        </div>
      </div>

      <div class="coach-btns-wrapper">
        <div class="red-btn user-btn" @click="onConfirm">确认更换</div>
        <div class="gray-btn user-btn" @click="onCancel">暂不更换</div>
      </div>
    </div>
    <!-- 更换成功 -->
    <div class="detail-box success-box" v-if="showSuccess">
      <van-icon class="success-icon" name="checked" color="#FF2270" />
      <div class="success-title">更换成功！</div>
      <div class="success-desc"
        >您的专属训练规划师已更换为<span class="light"
          >{{ coachNew['name'] }}教练</span
        ></div
      >
      <div class="success-btn user-btn" @click="onClose">我知道了</div>
    </div>
    <!-- 待店长联系提示 -->
    <div class="detail-box success-box success-box-tips" v-if="showSuccessTips">
      <van-icon class="success-icon" name="checked" color="#FF2270" />
      <div class="success-title">更换训练规划师申请已提交</div>
      <div class="success-desc"
        >您已提交更换训练规划师申请，在此之前，<span class="light"
          >店长将和您沟通身体情况及后续训练目标，以确保更换教练后能达到您的目标。</span
        ></div
      >
      <div class="success-desc"
        ><span class="light"
          >店长将在{{
            typeCode == 10099 ? '6小时内' : '次日'
          }}和您沟通相关事宜。</span
        >请您注意接听电话，谢谢。</div
      >
      <div class="success-btn user-btn" @click="onClose">我知道了</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainCoachPop',
  props: {
    coachNew: {
      type: Object,
      default: () => ({})
    },
    coachOld: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mainCoachShow: false,
      showConfirm: true,
      showSuccess: false,
      showSuccessTips: false,
      typeCode: 10099
    }
  },

  watch: {
    visible(nv) {
      this.mainCoachShow = nv
    }
  },

  methods: {
    onClose() {
      this.mainCoachShow = false
      this.showConfirm = false
      this.showSuccess = false
      this.showSuccessTips = false
    },

    // 取消（不更换）
    onCancel() {
      this.showConfirm = false
      this.$dialog({
        title: '提示',
        message: `【${this.coachNew['name']}】教练更了解您的身体情况，确定不让【${this.coachNew['name']}】教练为您编写训练计划吗？`,
        confirmButtonText: '确定不更换',
        cancelButtonText: '一键更换',
        showCancelButton: true
      })
        .then((action) => {
          // 不更换
          this.onSave(3)
        })
        .catch((err) => {
          // 一键更换
          this.onSave(1)
        })
    },

    onConfirm() {
      this.showConfirm = false
      this.$dialog({
        title: '请再次确认',
        message: `更换【${this.coachNew['name']}】教练为您的专属训练规划师？`,
        confirmButtonText: '确认更换',
        cancelButtonText: '不更换',
        showCancelButton: true
      })
        .then((action) => {
          // 确定更换
          this.onSave(1)
        })
        .catch((err) => {
          // 不更换
          this.onSave(3)
        })
    },

    async onSave(flag) {
      try {
        let res = await this.$http.get('member/ChangeApply', {
          a: 'saveApply',
          from_type: '1', // 约课提醒  2 推送 3 主动
          flag
        })
        if (res.data.code === 200) {
          if (flag == 1) {
            // 直接更换
            this.showSuccess = true
          } else {
            // 不更换
            // this.$dialog.alert({
            //   title: '提示',
            //   message:
            //     '如果您后期有需要，可以从【会员中心】-【我的团队教练】处申请更换专属训练规划师！'
            // })
            this.onClose()
          }
        } else if ([10098, 10099].includes(res.data.code)) {
          // 没有直接更换 提醒已提交 等待店长联系
          this.typeCode = res.data.code
          this.showSuccessTips = true
        } else {
          this.$dialog.alert({
            title: '提示',
            message: res.data.msg
          })
          this.onClose()
        }
        this.$http.get('member/index?a=shareLogPush', {
          from: `主责更换提醒弹窗-app-${flag == 1 ? '确认更换' : '暂不更换'}`,
          from_id: 25082190
        })
      } catch (err) {
        console.log(err)
        this.onClose()
      }
    },

    created() {}
  }
}
/* eslint-disable */
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.MainCoachPop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(#000, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  .detail-box {
    width: vw(301);
    box-sizing: border-box;
    border-radius: vw(8);
    background: #f7f7f7;
    padding: vw(34) vw(24) vw(24) vw(24);
    text-align: left;
    box-sizing: border-box;
    position: relative;
    .top-hello-text {
      font-weight: 600;
      font-size: vw(20);
      color: #050b27;
      line-height: vw(28);
      text-align: center;
    }
    .change-desc {
      font-size: vw(13);
      color: rgba(#050b27, 0.8);
      line-height: vw(20);
      margin-top: vw(14);
      .light {
        color: #ff2270;
      }
      .change-desc-text-1 {
        font-weight: 600;
        color: #050b27;
      }
    }
    .coach-change-wrapper {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      padding: vw(16);
      margin-top: vw(18);
      background: #ffffff;
      border-radius: vw(8);
      border: 1px solid #f1f1f1;
      .left-coach-wrapper,
      .right-coach-wrapper {
        max-width: vw(56);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .coach-avatar {
        width: vw(52);
        height: vw(52);
        border-radius: 50%;
        object-fit: cover;
        margin-bottom: vw(12);
      }
      .coach-name {
        width: max-content;
        text-align: center;
        font-size: vw(14);
        font-weight: 600;
        color: #252525;
      }
      .center-change-arrow {
        margin: vw(0) vw(13);
        padding-top: vw(5);
        display: flex;
        flex-direction: column;
        align-items: center;
        .change-text {
          width: max-content;
          text-align: center;
          font-size: vw(12);
          font-weight: normal;
          color: rgba(#050b27, 0.5);
        }
        img {
          width: vw(53);
          margin-top: vw(2);
        }
      }
    }

    .coach-btns-wrapper {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: vw(20);
      .red-btn {
        width: 100%;
        box-sizing: border-box;
        height: vw(40);
        background: #ff2270;
        box-shadow: 0px 1 1px 0px rgba(0, 0, 0, 0.1);
        border-radius: vw(20);
        font-size: vw(14);
        font-weight: 600;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .gray-btn {
        font-weight: 400;
        font-size: vw(12);
        color: #050b27;
        line-height: vw(17);
        margin-top: vw(20);
      }
    }
  }
  .success-box {
    padding-top: vw(30);
    display: flex;
    flex-direction: column;
    align-items: center;
    .success-icon {
      font-size: vw(50);
      color: #ff2270;
    }
    .success-title {
      font-weight: 600;
      font-size: vw(20);
      color: #050b27;
      line-height: vw(28);
      margin-top: vw(16);
    }
    .success-desc {
      width: 100%;
      box-sizing: border-box;
      text-align: left;
      margin-top: vw(13);
      font-weight: 400;
      font-size: vw(13);
      color: rgba(#050b27, 0.8);
      line-height: vw(20);
      .light {
        color: #ff2270;
      }
      & + .success-desc {
        margin-top: vw(6);
      }
    }
    .success-btn {
      width: 100%;
      box-sizing: border-box;
      height: vw(40);
      background: #ff2270;
      box-shadow: 0px 1 1px 0px rgba(0, 0, 0, 0.1);
      border-radius: vw(20);
      margin-top: vw(20);
      font-size: vw(14);
      font-weight: 600;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
<style lang="scss">
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.mint-msgbox .mint-msgbox-content .my_chang-coach-pop {
  .pop-text {
    font-size: vw(14);
    color: #000;
    span {
      color: #dc0050;
      font-weight: 600;
    }
    & + .pop-text {
      margin-top: vw(10);
    }
  }
}
</style>
